import { render } from "./TermsServiceContent.vue?vue&type=template&id=0c6a2b80"
import script from "./TermsServiceContent.vue?vue&type=script&lang=js"
export * from "./TermsServiceContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__